import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CloseIcon from '@material-ui/icons/Close';
import GalleryItem from './GalleryItem';
import GalleryButton from './GalleryButton';

const FullScreenGallery = ({ items, initialIndex, onClose }) => {
  const [selectedIndex, setSelectedIndex] = useState(initialIndex);

  const next = () => {
    const newSelected = selectedIndex + 1 === items.length ? 0 : selectedIndex + 1;
    setSelectedIndex(newSelected);
  };

  const prev = () => {
    const newSelected = selectedIndex === 0 ? items.length - 1 : selectedIndex - 1;
    setSelectedIndex(newSelected);
  };

  // This useEffect modifies the body so that it is fixed when the modal is shown
  // This prevents the body from scrolling
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    // Avoid width reflow when the modal is shown
    document.body.style.paddingRight = '10px';

    return () => {
      document.body.style.overflow = 'unset';
      document.body.style.paddingRight = '0';
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowRight') {
        next();
      } else if (event.key === 'ArrowLeft') {
        prev();
      } else if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, prev, next]);

  return (
    <>
      <div
        className="fixed top-0 left-0 w-full h-full z-modal bg-white bg-opacity-60"
        style={{ backdropFilter: 'blur(10px)' }}
      />
      <div
        className="fullScreenGallery fixed top-0 left-0 w-full h-full z-modal text-white"
        style={{ maxHeight: '600px' }}
      >
        <GalleryButton className="closeButton" right onClick={onClose}>
          <CloseIcon fontSize="large" />
        </GalleryButton>
        <GalleryButton className="prevButton" yCentered onClick={prev}>
          <ChevronLeftIcon fontSize="large" />
        </GalleryButton>
        <GalleryButton className="nextButton" right yCentered onClick={next}>
          <ChevronRightIcon fontSize="large" />
        </GalleryButton>
        <GalleryItem
          className="preview"
          border="none"
          description={items[selectedIndex]}
          size="full"
          url={items[selectedIndex]}
        />
      </div>
    </>
  );
};

FullScreenGallery.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  initialIndex: PropTypes.number,
  onClose: PropTypes.func,
};

FullScreenGallery.defaultProps = {
  initialIndex: 0,
  onClose: null,
};

export default FullScreenGallery;
